import Svg, { SvgProps } from './Svg';

export default function CookieIcon({ ...props }: SvgProps) {
  const id1 = 'linearGradient-cookieicon' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.5 8.5V8.51M16 15.5V15.51M12 12V12.01M11 17V17.01M7 14V14.01M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.305 12.214 20.5648 12.2345 19.8591 12.0593C19.1533 11.8841 18.5087 11.5198 17.9945 11.0056C17.4803 10.4913 17.116 9.8467 16.9407 9.14094C16.7655 8.43517 16.786 7.69499 17 7C16.305 7.214 15.5648 7.23449 14.8591 7.05927C14.1533 6.88405 13.5087 6.51975 12.9945 6.00555C12.4803 5.49135 12.116 4.8467 11.9407 4.14094C11.7655 3.43517 11.786 2.69499 12 2Z"
        stroke={`url(#${id1})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
      <defs>
        <linearGradient
          id={id1}
          x1="-2.13793"
          y1="-3.27778"
          x2="23.7291"
          y2="3.64808"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFC555"></stop>
          <stop offset="1" stopColor="#FB4AB9"></stop>
        </linearGradient>
      </defs>
    </Svg>
  );
}
